module.exports = __webpack_public_path__ + "media/images/where-assets-icon-bolo-d3068688d4014d3a0441764998a520a9.svg";